import React from "react";
import "../styles/Product.css";
import star from "../images/star.svg";
import { useStateValue } from "../StateProvider";
import { Link } from "react-router-dom";

function Product({ id, title, price, rating, image }) {
  // this is the useContext
  const [{ basket }, dispatch] = useStateValue();
  console.log(basket);
  //dispatch is coming from the reducer.js
  const addToBasket = () => {
    dispatch({
      type: "ADD_TO_BASKET",
      item: {
        id: id,
        title: title,
        image: image,
        price: price,
        rating: rating,
      },
    });
  };

  return (
    <div className="product__container">
      <Link className="product__link" to={`/details/${id}`}>
        <div className="product">
          <div className="product__info">
            <p>{title}</p>
            <p className="product__price">
              <small>$</small>
              <strong> {price}</strong>
            </p>
            <div className="product_rating">
              {Array(rating).fill(<img src={star} alt="" width="20" />)}
            </div>
          </div>

          <img src={image} alt="" />
        </div>
      </Link>
      <button onClick={addToBasket}>Add to Basket</button>
    </div>
  );
}

export default Product;
